import {
    useShockwaveContentsQuery,
    useShockwaveLocationsQuery,
} from "@/features/shockwave/api";

export default function useShockwaveDetailsOptions() {
    const { data: shockwaveLocations } = useShockwaveLocationsQuery();
    const { data: shockwaveContents } = useShockwaveContentsQuery();

    return {
        shockwaveLocations,
        shockwaveContents,
    };
}
